import styles from './RadioButton.module.css'

interface RadioButton {
  label: string,
  name: string,
  id: string,
  value: number | undefined,
  checked: boolean,
  onChange: () => void
}

function RadioButton({
  label,
  name,
  id,
  value,
  onChange,
  checked,
}: RadioButton) {
  return (
    <div>
      <input
        className={styles.input}
        id={id}
        name={name}
        type="radio"
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <label className={styles.label} htmlFor={id}>
        <span className={styles.icon}></span>
        <span className={styles.name}>{label}</span>
      </label>
    </div>
  )
}

export default RadioButton
